import { AxiosError, AxiosResponse } from 'axios';
import api from '../../config/index';
import { PrintRuleHistory } from '~/@core/domain/model/tag';

export const getPrintRuleHistory = (id: number) => {
  return new Promise<PrintRuleHistory>((resolve, reject) => {
    api
      .get<void, AxiosResponse<PrintRuleHistory>>(`/tag/history/${id}`)
      .then((response: AxiosResponse<PrintRuleHistory>) => {
        resolve(response.data);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
};
